<template>
  <div>
    <input
      id="user-id"
      type="hidden"
      v-model="galeria.usuario"
    />
    <input
      id="galeria-id"
      type="hidden"
      v-model="galeria.id"
    />
    <input
      id="galeria-uuid"
      type="hidden"
      v-model="galeria.uuid"
    />
    <input
      id="uid_noticia"
      type="hidden"
      v-model="galeria.uid_noticia"
    />
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-autocomplete
          v-model="galeria.uid_subcategoria"
          :items="subcategorias"
          required
          dense
          outlined
          label="Subcategoria"
        >
        </v-autocomplete>
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-autocomplete
          v-model="galeria.tipo"
          :items="tipoGaleria"
          required
          dense
          outlined
          label="Tipo de galeria"
        >
        </v-autocomplete>
      </v-col>
      <v-col
        cols="12"
        md="2"
        v-if="galeria.id"
      >
        <v-checkbox
          v-model="galeria.inativar"
          label="Inativar galeria?"
          color="success"
          class="mt-0 mb-2"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <v-text-field
          v-model="galeria.titulo"
          label="Título da galeria"
          outlined
          required
          dense
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <v-text-field
          v-model="galeria.subtitulo"
          label="Subtítulo da galeria"
          outlined
          required
          dense
        >
        </v-text-field>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'FormGaleria',
  props: {
    galeria: {}, subcategorias: [], tipoGaleria: [], mode: { type: String, default: 'save' }
  }
}
</script>
